<div class="search-input">
  <mat-form-field [class]="!isMaterialLabel ? 'custom-label' : ''">
    <mat-label *ngIf="isMaterialLabel && label">{{ label }}</mat-label>
    <input
      (change)="valueChanged()"
      [autocomplete]="autocomplete"
      [formControl]="control"
      [id]="inputId"
      [placeholder]="placeholder"
      [readonly]="isControlDisabled"
      matInput
      type="text"
    />
    <span
      *ngIf="characterCountLimit"
      class="search-input__character-count"
      matTextSuffix
    >
      {{ control.value?.length ?? 0 }}/{{ characterCountLimit }}
      characters
    </span>
    <button
      *ngIf="!(clearEnabled && control.value)"
      (click)="onSearch($event)"
      [class]="searchDisabled ? 'no-pointer' : ''"
      [disabled]="searchDisabled || control.hasError('maxlength')"
      aria-label="search"
      mat-icon-button
      matSuffix
    >
      <mat-icon> search </mat-icon>
    </button>
    <button
      *ngIf="clearEnabled && control.value"
      (click)="onClear($event)"
      [class]="searchDisabled ? 'no-pointer' : ''"
      [disabled]="!control.value"
      aria-label="clear"
      mat-icon-button
      matSuffix
    >
      <mat-icon> clear </mat-icon>
    </button>
    <mat-error *ngIf="control.hasError('maxlength')">
      {{
        'Field must be no more than ' +
          control.getError('maxlength')['requiredLength'] +
          ' characters'
      }}
    </mat-error>
    <mat-error *ngIf="control.hasError('addressNotFound')">
      {{ control.getError('addressNotFound') }}
    </mat-error>
  </mat-form-field>
</div>
